var _path, _path2, _circle, _circle2, _circle3, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclein5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 489,
    viewBox: "0 0 488 489",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.729 41.0723C240.701 39.1093 242.269 37.4919 244.233 37.4971C246.196 37.5024 247.755 39.1281 247.717 41.0909L247.266 63.9035C247.233 65.5888 245.84 66.9254 244.154 66.9209C242.468 66.9164 241.082 65.5724 241.058 63.8869L240.729 41.0723Z",
    fill: "#889BD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8003 243.7C35.8003 358.575 128.925 451.7 243.8 451.7C358.676 451.7 451.8 358.575 451.8 243.7C451.8 128.825 358.676 35.7003 243.8 35.7003C128.925 35.7003 35.8003 128.825 35.8003 243.7ZM420.6 243.7C420.6 341.344 341.444 420.5 243.8 420.5C146.156 420.5 67.0003 341.344 67.0003 243.7C67.0003 146.056 146.156 66.9003 243.8 66.9003C341.444 66.9003 420.6 146.056 420.6 243.7Z",
    fill: "#3B3D4B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "matrix(-1 0 0 1 91.3545 323)",
    fill: "#889BD3",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "matrix(-1 0 0 1 426.354 323)",
    fill: "#889BD3",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "matrix(-1 0 0 1 259.354 35.7002)",
    fill: "#889BD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M246.625 40.0723C246.654 38.1093 245.085 36.4919 243.122 36.4971C241.159 36.5024 239.599 38.1281 239.638 40.0909L240.088 62.9035C240.122 64.5888 241.515 65.9254 243.2 65.9209C244.886 65.9164 246.272 64.5724 246.297 62.8869L246.625 40.0723Z",
    fill: "#889BD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M228.897 50.7051C228.309 42.9955 234.085 36.2192 241.817 36.1501C275.056 35.8529 307.957 43.5212 337.733 58.6005C371.68 75.7928 400.266 101.961 420.384 134.261C440.502 166.561 451.382 203.757 451.842 241.807C452.302 279.857 442.324 317.305 422.992 350.082C403.661 382.859 375.715 409.71 342.193 427.718C308.671 445.725 270.854 454.2 232.853 452.222C194.851 450.243 158.119 437.887 126.648 416.495C99.0446 397.733 76.415 372.65 60.5928 343.416C56.9124 336.616 60.048 328.283 67.0799 325.067L69.9763 323.743C77.0081 320.528 85.2667 323.655 89.0274 330.411C102.425 354.479 121.291 375.147 144.178 390.704C170.935 408.892 202.165 419.397 234.474 421.079C266.783 422.761 298.935 415.556 327.436 400.246C355.936 384.936 379.696 362.107 396.131 334.24C412.567 306.373 421.051 274.534 420.66 242.184C420.269 209.834 411.019 178.209 393.914 150.748C376.81 123.286 352.506 101.038 323.643 86.4211C298.955 73.9178 271.738 67.4075 244.193 67.3273C236.461 67.3048 229.728 61.5902 229.14 53.8807L228.897 50.7051Z",
    fill: "#889BD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclein5);
export default __webpack_public_path__ + "static/media/circlein5.39eaf8875d903c1619f34a5946350e92.svg";
export { ForwardRef as ReactComponent };